import React from 'react';
import { Card } from '../common/Card';
import { Heading, Text } from '../common/Typography';

const features = [
  {
    title: 'Better games',
    description:
      'Clubs can use a matchmaking system built from real club sessions to reduce the common pain points like repeat pairings, lopsided games, long wait times.',
    iconBg: 'bg-primary-light text-primary',
    icon: (
      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3l7 4v5c0 4.4-3 8.2-7 9-4-.8-7-4.6-7-9V7l7-4z" />
      </svg>
    ),
  },
  {
    title: 'Run club sessions better',
    description:
      'Plan sessions, take sign-ups, and keep courts moving, with less time spent organising.',
    iconBg: 'bg-success-light text-success-dark',
    icon: (
      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3M5 11h14M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    title: 'Find your next game',
    description:
      'Discover public clubs, request to join, and sign up for upcoming sessions before courts fill up.',
    iconBg: 'bg-primary-light text-primary',
    icon: (
      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M11 18a7 7 0 100-14 7 7 0 000 14z" />
      </svg>
    ),
  },
  {
    title: 'Track how you are playing',
    description:
      'After you play, results feed into game history, club Elo, and season leaderboards.',
    iconBg: 'bg-success-light text-success-dark',
    icon: (
      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 17l6-6 4 4 8-8M13 7h8v8" />
      </svg>
    ),
  },
];

const LandingFeatures = () => (
  <section id="features" className="scroll-mt-24 px-4 py-12 sm:px-6 md:scroll-mt-8 lg:px-10 lg:py-16">
    <div className="mx-auto grid max-w-app-shell gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
      {features.map((feature) => (
        <Card key={feature.title} variant="default" className="p-6">
          <div className="mb-2 flex items-start gap-3">
            <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${feature.iconBg}`}>
              {feature.icon}
            </div>
            <Heading level={3} className="pt-1.5 text-lg">{feature.title}</Heading>
          </div>
          <Text className="text-sm text-text-secondary">{feature.description}</Text>
        </Card>
      ))}
    </div>
  </section>
);

export default LandingFeatures;
